module.exports = __webpack_public_path__ + "img/store-speed-40_60.d6ec8543.svg";